import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { from } from 'rxjs';

import { AccountService } from 'src/app/core/services/account.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/core/services/spinner.service';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.css'],
})
export class DeleteAccountComponent implements OnInit {
  @Output() deletedAccount: EventEmitter<boolean> = new EventEmitter();
  public deleteForm: FormGroup;
  public textType: boolean;
  public invalidPassword = false;

  constructor(
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerService,
    private accountService: AccountService,
    private router: Router,
    private authService: AuthService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.preparePasswordForm();
  }

  preparePasswordForm(): void {
    this.deleteForm = this.formBuilder.group({
      password: ['', Validators.required],
    });
  }

  toggleTextType() {
    this.textType = !this.textType;
  }

  onSubmit() {
    if (this.deleteForm.valid) {
      this.invalidPassword = false;
      this.spinnerService.show();
      from(
        this.accountService.deleteAccount(this.deleteForm.get('password').value)
      )
        .pipe(finalize(() => this.spinnerService.hide()))
        .subscribe(
          (res) => {
            this.activeModal.close();
            this.authService.logout();
            this.router.navigate(['deleted-account']);
          },
          (err) => {
            this.invalidPassword = true;
          }
        );
    }
  }
}
